import { HStack, Text, VStack } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";

const pad = (n: number) => String(n).padStart(2, "0");

/** Tykający odlicznik do `target` (ISO). Białe „kostki" na ciemnym hero. */
export const Countdown: React.FC<{ target: string }> = ({ target }) => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  const diff = Math.max(0, new Date(target).getTime() - now);
  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);

  const units = [
    { v: d, l: "dni" },
    { v: h, l: "godz" },
    { v: m, l: "min" },
    { v: s, l: "sek" }
  ];

  return (
    <HStack spacing={{ base: "8px", md: "11px" }}>
      {units.map((u, i) => (
        <VStack
          key={i}
          spacing="2px"
          bg="rgba(255,255,255,0.12)"
          border="1px solid rgba(255,255,255,0.18)"
          backdropFilter="blur(6px)"
          borderRadius="15px"
          px={{ base: "12px", md: "16px" }}
          py={{ base: "9px", md: "11px" }}
          minW={{ base: "58px", md: "68px" }}
        >
          <Text fontSize={{ base: "24px", md: "30px" }} fontWeight="800" lineHeight="1" sx={{ fontVariantNumeric: "tabular-nums" }}>
            {pad(u.v)}
          </Text>
          <Text fontSize="10.5px" opacity={0.72} textTransform="uppercase" letterSpacing="0.06em">
            {u.l}
          </Text>
        </VStack>
      ))}
    </HStack>
  );
};
